import { routerRedux } from 'dva/router';
import Moment from 'moment';
import { setCookie } from 'root/utils/utils';
import { fakeAccountLogin, queryAllDefaultPage, loginout, checkThirdPart, checkADEnv, getLoginUserInfo } from '../services/api';
import { setAuthority, loginActions, isAdmin, erpLogout, loginBap } from '../utils/authority';

export default {
  namespace: 'login',
  state: {
    visible: false,
    mutliCompanyModalVisable: false,
    status: undefined,
    errMsg: '',
    outType: undefined,
    loginResponse: {}
  },

  effects: {
    *login({ payload }, { call, put }) {
      // 登出erp
      const { source } = yield call(checkThirdPart);
      if (source === 'erp') {
        erpLogout();
      }
      const response = yield call(fakeAccountLogin, payload);
      setCookie('suposTicket', response.ticket);
      localStorage.setItem('ticket', response.ticket);
      yield put({
        type: 'updateLoginStore',
        payload: { loginResponse: response }
      });
      // 登录bap
      if (source === 'bap') {
        loginBap();
      }
      yield put({
        type: 'setLoginInfo',
        payload,
        response
      });
    },
    *thirdLogin({ payload }, { call, put }) {
      const { ticket } = payload;
      setCookie('suposTicket', ticket);
      localStorage.setItem('ticket', ticket);
      const response = yield call(getLoginUserInfo, payload);
      payload = { ...payload, username: response.username };
      if (response.code === 401) {
        yield put(routerRedux.push('/user/login'));
        return false;
      }
      yield put({
        type: 'updateLoginStore',
        payload: { loginResponse: response }
      });
      yield put({
        type: 'setLoginInfo',
        payload,
        response
      });
    },
    *setLoginInfo({ payload, response }, { call, put, take }) {
      // 判断是否是AD环境
      const envDate = yield call(checkADEnv);

      // AD环境首次登录不需要重置密码
      if (envDate && envDate.type === 'AD' && response.username !== 'admin') {
        response.status = response.status === 'firstLogin' ? 'ok' : response.status;
      }
      if (response && (response.status === 'ok' || (response.status === 'firstLogin' && +response.code !== 401.3))) {
        // 设置pims的cookie
        yield put({
          type: 'setCookie'
        });
        // 登录前检查多组织
        // 拉取组织列表
        yield put({
          type: 'user/fetchMulitCompany',
          payload
        });
        yield take('user/fetchMulitCompany/@@end');
        // 检查是否需要重新选择组织
        let isReselect = yield put({
          type: 'user/checkMulitCompanyReselect',
          payload
        });
        yield take('user/checkMulitCompanyReselect/@@end');
        isReselect = yield isReselect;
        // 需要重新选择组织
        if (isReselect) {
          yield put({
            type: 'updateLoginStore',
            payload: { mutliCompanyModalVisable: isReselect }
          });
          return false;
        }
        // 不需要选择直接登录
        yield put({
          type: 'changeOrginalCompany',
          payload
        });
      }

      let errMsg = '';
      if (response.status === 'error') {
        errMsg = response.message || response.error;
        if (response.code === 401.2) {
          errMsg = response.message + Moment(new Date(response.lockTime)).format('YYYY-MM-DD HH:mm:ss');
        }
      }
      if (response.status === 'firstLogin' && response.code === 401.3) {
        errMsg = `${response.message}, 3秒后自动跳转修改密码`;
        const delay = ms => new Promise(resolve => setTimeout(resolve, ms));
        yield call(delay, 3000);
        yield put({
          type: 'loginJump',
          payload,
          response
        });
      }
      if (response.code - 0 === 400 && response.message) {
        errMsg = response.message;
      }
      yield put({
        type: 'updateLoginMessage',
        payload: {
          errMsg
        }
      });
    },
    *changeOrginalCompany({ payload }, { put, select }) {
      const { loginResponse } = yield select(state => state.login);
      // fetch 切换的组织
      yield put({
        type: 'user/changeOrginalCompany',
        payload
      });
      // 隐藏modal
      yield put({
        type: 'updateLoginStore',
        payload: { mutliCompanyModalVisable: false }
      });
      // 根据登录信息跳转
      yield put({
        type: 'loginJump',
        payload,
        response: loginResponse
      });
    },
    *setCookie(_, { call }) {
      const { source } = yield call(checkThirdPart);
      if (source === 'pims') {
        document.cookie = 'supcon.pims.data.username=admin;path=/';
      }
    },
    *loginJump({ payload, response }, { call, put, select }) {
      const { redirectUrl } = payload;
      loginActions(payload, response);
      yield put({
        type: 'changeLoginStatus',
        payload: {
          status: true,
          currentAuthority: isAdmin(response)
        }
      });
      if (redirectUrl && redirectUrl !== '') {
        window.location.href = decodeURIComponent(redirectUrl);
        return false;
      }
      const { currentCompanyOrganization } = yield select(state => state.user);
      const defaultPage = yield call(queryAllDefaultPage, { companyId: currentCompanyOrganization });
      if (defaultPage && defaultPage.personal && defaultPage.personal.url) {
        localStorage.setItem('personalPage', `/${defaultPage.personal.url}`);
      }
      if (defaultPage && defaultPage.system) {
        if (defaultPage.system.url) {
          localStorage.setItem('defaultPage', `/${defaultPage.system.url}`);
        } else {
          localStorage.setItem('defaultPage', '/hellow');
        }
      }
      const url = !localStorage.getItem('personalPage') ? localStorage.getItem('defaultPage') : localStorage.getItem('personalPage');
      yield put(routerRedux.push(`${url}`));
    },
    *logout(_, { call, put }) {
      yield call(loginout);
      try {
        yield put(routerRedux.push('/user/login'));
      } finally {
        localStorage.removeItem('personalPage');
        localStorage.removeItem('defaultPage');
        yield put({
          type: 'changeLoginStatus',
          payload: {
            status: false,
            currentAuthority: 'guest'
          }
        });
      }
    },
    *modelLogin({ payload, callback }, { call, put, take, select }) {
      // 登出erp
      const { source } = yield call(checkThirdPart);
      if (source === 'erp') {
        erpLogout();
      }

      const response = yield call(fakeAccountLogin, payload);

      // 登录bap
      if (source === 'bap') {
        loginBap();
      }

      if (response && (response.status === 'ok' || response.status === 'firstLogin')) {
        loginActions(payload, response);
        // 拉取组织列表
        yield put({
          type: 'user/fetchMulitCompany',
          payload
        });
        yield take('user/fetchMulitCompany/@@end');
        yield put({
          type: 'user/checkMulitCompanyReselect',
          payload
        });
        yield take('user/checkMulitCompanyReselect/@@end');
        yield put({
          type: 'user/changeOrginalCompany',
          payload
        });

        const { currentCompanyOrganization } = yield select(state => state.user);
        yield put({
          type: 'user/updateDefaultPage',
          payload: { companyId: currentCompanyOrganization }
        });

        yield put({
          type: 'changeLoginStatus',
          payload: {
            status: true,
            visible: false,
            currentAuthority: isAdmin(response)
          }
        });

        // 设置pims的cookie
        yield put({
          type: 'setCookie'
        });
      }
      if (callback) callback(response);
    },
    *modelLogout({ payload }, { put }) {
      yield put({
        type: 'loginMomal',
        payload: {
          status: false,
          visible: true,
          currentAuthority: 'guest',
          outType: payload && payload.outType
        }
      });
    }
  },
  reducers: {
    changeLoginStatus(state, { payload }) {
      setAuthority(payload.currentAuthority);
      return {
        ...state,
        status: payload.status,
        visible: payload.visible || false,
        type: payload.type
      };
    },
    updateLoginMessage(state, { payload }) {
      return {
        ...state,
        errMsg: payload.errMsg
      };
    },
    updateLoginStore(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
    loginMomal(state, { payload }) {
      setAuthority(payload.currentAuthority);
      return {
        ...state,
        ...payload
      };
    }
  }
};
